import {useEffect, useState} from 'react';
import {userStore} from '../../userStore/userStore';
import styles from './SearchPage.module.css';
import EventEmitter from 'events';

type Props = {
	onSelect: (search: string) => void;
	emitter: EventEmitter;
	onNoLastSearches: () => void;
};

const useLastSearch = ({onSelect, emitter, onNoLastSearches}: Props) => {
	const [searches, setSearches] = useState<string[]>(userStore.getSearches());

	const handleSearchClick = (search: string) => {
		onSelect(search);
		userStore.addSearch(search);
		setSearches(userStore.getSearches());
	};

	const handleCloseSearch = (search: string) => {
		userStore.removeSearch(search);
		setSearches(userStore.getSearches());
	};

	useEffect(() => {
		if (!searches.length) {
			onNoLastSearches();
		}
	}, [searches]);

	const refresh = () => {
		setSearches(userStore.getSearches());
	};

	useEffect(() => {
		emitter.on('refresh', refresh);
		return () => {
			emitter.off('refresh', refresh);
		};
	}, [emitter]);

	return {
		searches,
		handleSearchClick,
		handleCloseSearch,
	};
};

export const LastSearchBlock = ({
	onSelect,
	emitter,
	onNoLastSearches,
}: Props) => {
	const {searches, handleSearchClick, handleCloseSearch} =
		useLastSearch({onSelect, emitter, onNoLastSearches});

	if (!searches.length) {
		onNoLastSearches();
		return null;
	}

	return (
		<div className={styles.searches}>
			<p className={styles.searchesTitle}>Last search</p>
			{searches.map((search) => (
				<div key={search} className={styles.searchItem}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
					>
						<path
							d="M0.0606689 5.10059C0.0606689 2.28823 2.3489 0 5.16126 0C7.97361 0 10.2618 2.28823 10.2618 5.10059C10.2618 6.26388 9.87195 7.3313 9.2136 8.18779L11.7283 10.7217C11.8625 10.8559 11.9392 11.0412 11.9392 11.2458C11.9392 11.674 11.6388 12 11.2042 12C10.9996 12 10.8079 11.9297 10.6609 11.7827L8.12701 9.24242C7.2897 9.84324 6.27341 10.2012 5.16126 10.2012C2.3489 10.2012 0.0606689 7.91294 0.0606689 5.10059ZM1.15365 5.10059C1.15365 7.31212 2.94972 9.10819 5.16126 9.10819C7.37279 9.10819 9.16886 7.31212 9.16886 5.10059C9.16886 2.88905 7.37279 1.09298 5.16126 1.09298C2.94972 1.09298 1.15365 2.88905 1.15365 5.10059Z"
							fill="#5A5976"
						/>
					</svg>
					<p
						className={styles.searchText}
						onClick={() => handleSearchClick(search)}
					>
						{search}
					</p>
					<div
						className={styles.close}
						onClick={() => handleCloseSearch(search)}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
						>
							<path
								d="M13.9953 3.34763C14.3661 2.97681 14.3661 2.37559 13.9953 2.00477C13.6245 1.63395 13.0232 1.63395 12.6524 2.00477L8.00004 6.65715L3.34766 2.00477C2.97684 1.63395 2.37562 1.63395 2.0048 2.00477C1.63398 2.37559 1.63398 2.97681 2.0048 3.34763L6.65718 8.00001L2.0048 12.6524C1.63398 13.0232 1.63398 13.6244 2.0048 13.9952C2.37562 14.3661 2.97684 14.3661 3.34766 13.9952L8.00004 9.34287L12.6524 13.9952C13.0232 14.3661 13.6245 14.3661 13.9953 13.9952C14.3661 13.6244 14.3661 13.0232 13.9953 12.6524L9.3429 8.00001L13.9953 3.34763Z"
								fill="#5A5976"
							/>
						</svg>
					</div>
				</div>
			))}
		</div>
	);
};
